<h2 mat-dialog-title>Archive {{ user.name }}?</h2>

<mat-dialog-content>
  <p>
    Archiving the user will remove access from the user and remove them as an
    option for assigning tasks.
  </p>
  <p>
    Any remaining credits for this user will be credited towards your next bill.
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="cancel()">Cancel</button>
  <button mat-raised-button color="warn" (click)="accept()">Archive</button>
</mat-dialog-actions>
